import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "../../styles/Buttons.css";
import { getTemplateById } from "./templateService";

export default function DataBindingModal({
  show,
  binding,
  onClose,
  onSave,
  templateId,
  children
}) {

  const [fields, setFields] = useState([]);
  const [fieldKey, setFieldKey] = useState(binding?.fieldKey || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show) return;

    setFieldKey(binding?.fieldKey || "");
    setError("");
  }, [show, binding]);

  useEffect(() => {
    if (!show || !templateId) return;

    let alive = true;

    (async () => {
      try {
        setLoading(true);

        const tpl = await getTemplateById(templateId);
        if (!alive) return;

        const flds = Array.isArray(tpl?.fields) ? tpl.fields : [];
        setFields(flds);
      } catch (err) {
        console.error(err);
        if (alive) setError("Failed to load template fields.");
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => { alive = false; };
  }, [show, templateId]);

  function handleSave() {
    if (!fieldKey) {
      setError("Please select a field.");
      return;
    }

    onSave({
      templateId,
      fieldKey,
      conditions: binding?.conditions || []
    });
  }

  function handleClear() {
    onSave(null);
    onClose();
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      container={document.body}
    >

      <Modal.Header closeButton>
        <Modal.Title>Bind to Template Field</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {loading && <div>Loading fields…</div>}
        {error && <div className="dbm-error">{error}</div>}

        {!loading && templateId && (
          <div className="dbm-bind-row">

            <label>Template Field</label>

            <select
              value={fieldKey}
              onChange={(e) => setFieldKey(e.target.value)}
            >
              <option value="">— Select Field —</option>
              {fields.map((f) => (
                <option key={f.key} value={f.key}>
                  {f.label || f.key}
                </option>
              ))}
            </select>

            {binding?.fieldKey && (
              <button className="btn-red" onClick={handleClear}>
                Clear
              </button>
            )}

            <button
              className="btn-green"
              onClick={handleSave}
              disabled={!fieldKey}
            >
              Bind
            </button>

          </div>
        )}

        {children}

      </Modal.Body>

      <Modal.Footer>
        <button className="btn-gray" onClick={onClose}>
          Close
        </button>
      </Modal.Footer>

    </Modal>
  );
}
